<app-loading-bar></app-loading-bar>
<router-outlet></router-outlet>
